import BooleanFormField from './components/BooleanFormField';
import BooleanInputField from './components/BooleanInputField';
import CodeFormField from './components/CodeFormField';
import CodeInputField from './components/CodeInputField';
import ColorFormField from './components/ColorFormField';
import DateFormField from './components/DateFormField';
import DateInputField from './components/DateInputField';
import DatetimeFormField from './components/DatetimeFormField';
import FileFormField from './components/FileFormField';
import FileInputField from './components/FileInputField';
import NumberFormField from './components/NumberFormField';
import NumberInputField from './components/NumberInputField';
import OptionsFormField from './components/OptionsFormField';
import OptionsInputField from './components/OptionsInputField';
import StringFormField from './components/StringFormField';
import StringInputField from './components/StringInputField';

function install(Vue) {
  if (install.installed) return;

  install.installed = true;

  Vue.component('boolean-form-field', BooleanFormField);
  Vue.component('boolean-input-field', BooleanInputField);
  Vue.component('code-form-field', CodeFormField);
  Vue.component('code-input-field', CodeInputField);
  Vue.component('color-form-field', ColorFormField);
  Vue.component('date-form-field', DateFormField);
  Vue.component('date-input-field', DateInputField);
  Vue.component('datetime-form-field', DatetimeFormField);
  Vue.component('file-form-field', FileFormField);
  Vue.component('file-input-field', FileInputField);
  Vue.component('number-form-field', NumberFormField);
  Vue.component('number-input-field', NumberInputField);
  Vue.component('options-form-field', OptionsFormField);
  Vue.component('options-input-field', OptionsInputField);
  Vue.component('string-form-field', StringFormField);
  Vue.component('string-input-field', StringInputField);
}

export default {
  install
};
